<template>
  <Select :selected.sync="selectedId" :clearable="true" :data="lists" placeholder="请选择" />
</template>

<script>

import Select from './index'

export default {
  name: 'TextBookSelect',
  components: {
    Select
  },
  props: {
    selected: {
      type: [Number, String],
      required: true,
      default: 0
    },
    subjectId: {
      type: [Number, String],
      required: true,
      default: 0
    }
  },

  data() {
    return {
      lists: []
    }
  },
  computed: {
    selectedId: {
      get() {
        return this.selected
      },
      set(val) {
        this.$emit('update:selected', val)
      }
    }
  },
  watch: {
    subjectId: {
      immediate: true, // 这句重要
      handler(val) {
        this.getLists()
      }
    }

  },
  created() {
    this.selectedId = this.selected
  },

  methods: {
    getLists() {
      this.$http.tyyGetTextBook({ subject_id: this.subjectId }).then(res => {
        res.data.forEach(element => {
          element.id = element.book_id
          element.name = element.book_name
        })
        this.lists = res.data
      })
    }
  }
}
</script>

<style scoped>

</style>
